import { Component, OnInit } from '@angular/core';
import { ConfigService } from '../../../services/config.service';

@Component({
    selector: 'px-a00010-header-logo',
    templateUrl: './a00010-header-logo.component.html',
    styleUrls: ['./a00010-header-logo.component.scss']
})
export class A00010HeaderLogoComponent implements OnInit {
    srcsetValue: string;
    constructor(private config: ConfigService) {
        const mobileLogo =  `${this.config.getBasePath()}/IMG/mitsubishi-logo-mobile.png 104w`;
        const desktopLogo =  `${this.config.getBasePath()}/IMG/mitsubishi-logo.png        148w`;

        this.srcsetValue = `${mobileLogo}, ${desktopLogo}`;
    }

    ngOnInit(): void {}
}
